export const LOAD_STREAM = 'LOAD_STREAM';
export const STOP_STREAM = 'STOP_STREAM';


// WEBPACK FOOTER //
// ./js/actions/Stream.js